import React from "react";
import { MdErrorOutline } from "react-icons/md";
import { Link } from "react-router-dom";

const RecoverPasswordRequestFailed = () => {
  return (
    <>
      <img className="login-logo" src="assets/images/ll2.png" alt="logo" />
      <div
        className="mt-5"
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="col-lg-5 mt-5">
          <div className="card mb-0 mt-5">
            <div className="card-body">
              <div className="mb-4 text-center">
                <MdErrorOutline style={{ fontSize: "100px", color: "red" }} />

                <p
                  className="my-2 mt-4"
                  style={{ fontFamily: "Montserrat", fontSize: "18px" }}
                >
                  Recovery request failed. Please try again.
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Link
                  to="/login"
                  style={{ color: "white" }}
                  className="btn btn-primary btn-lg w-50"
                >
                  Back to Login{" "}
                </Link>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecoverPasswordRequestFailed;
